import { createFileRoute, redirect } from "@tanstack/react-router";
// UI
import { SpringHealthLoginPage } from "@pages/spring-health-log-in-page";
// query
import { queryClient } from "@config/tanstack/tanstackQuery";
import { userInfoQueryOpts } from "src/backendApi/queries/authentication";
import { backendApiV2 } from "src/backendApi/backendApi";
//
import type { V3UserInfo } from "@neuromotion-inc/mightier-ts-sdk";

import type { SpringRegisterSearchParams } from "./register";

interface SpringLoginLoaderData {
  isLoggedIn: false;
}

export const Route = createFileRoute("/spring-health/register/log-in")({
  component: SpringHealthLoginPage,
  loaderDeps: (opts): SpringRegisterSearchParams => {
    return { ...opts.search };
  },
  loader: async (ctx): Promise<SpringLoginLoaderData> => {
    // returning this is basically just a no-op (allow user to proceed to the login page)
    const RET: SpringLoginLoaderData = { isLoggedIn: false };

    let userInfo: V3UserInfo | undefined;

    try {
      userInfo = await queryClient.ensureQueryData({
        ...userInfoQueryOpts(),
        //
        staleTime: 5000,
      });
    } catch (err) {
      // failure is most likely due to not-logged-in . In a perfect world we'd verify,
      // but for sake of saving time we're going to assume.
      // Nothing to do i
      return RET;
    }

    const paramEmail = ctx.deps.email_address;
    const loggedInUserEmail = userInfo.email;

    const emailMatches =
      paramEmail.toLowerCase() === loggedInUserEmail.toLowerCase();

    console.log({
      paramEmail,
      loggedInUserEmail,
      emailMatches,
    });

    // email matches so no need to log in
    if (emailMatches) {
      console.log("User is logged in for correct email address - redirecting.");
      throw redirect({
        to: "/spring-health/register/enroll",
        search: { ...ctx.deps },
      });
    }

    // otherwise, automatically log out for the user
    console.log("Logged in user email address does not match. Log out!");
    await backendApiV2.sessionAuthLogout();
    return RET;
  },
});
